enum PropertyDataType {
  GET_PROPERTIES_DATA_REQUEST = 'properties/getPropertiesDataRequest',
  GET_PROPERTIES_DATA_REJECTED = 'properties/getPropertiesDataRejected',
  GET_PROPERTIES_DATA_FULFILLED = 'properties/getPropertiesDataFulfilled',
}

export const propertyRoomIcons: Record<string, string> = {
  'living room':
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/Living_room_icon-removebg-preview.png',
  kitchen:
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/Kitchen_icon-removebg-preview.png',
  bathroom:
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/bathroom_icon-removebg-preview.png',
  'dining room':
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/Dining_room_icon-removebg-preview.png',
  hallway:
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/Hallway_icon-removebg-preview.png',
  'master bedroom':
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/master_bedroom_icon-removebg-preview.png',
  bedroom1:
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/bedroom_1-removebg-preview.png',
  bedroom2:
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/bedroom_2-removebg-preview.png',
  bedroom3:
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/bedroom_3-removebg-preview.png',
  bedroom4:
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/bedroom_4-removebg-preview.png',
  'master bath':
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/bathroom_icon-removebg-preview.png',
  balcony:
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/balcony_icon-removebg-preview.png',
  yard:
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/yard_icon-removebg-preview.png',
  'home office':
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/home_office_icon-removebg-preview.png',
  'boy room':
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/Boy_room_icon-removebg-preview.png',
  'girl room':
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/girl_room_icon-removebg-preview.png',
  'closet room':
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/closet_room_room_icon-removebg-preview.png',
  outside:
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/outside_area_icon-removebg-preview.png',
  unassigned:
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/bedroom_1-removebg-preview.png',
  'guest toilet':
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/guest_toilet_icon-removebg-preview.png',
  'baby room':
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/baby_room_room_icon-removebg-preview.png',
  'utility area':
    'https://patricia-ai-data-staging.s3.eu-central-1.amazonaws.com/mody-pdf/room-icons/utility_area_icon-removebg-preview.png',
};

export default PropertyDataType;
